type Props = {
  deadlineText: string;
  flashDealLabel?: string;
  secondaryText: string;
  textClassName: string;
};

export function UrgencyBarText({
  deadlineText,
  flashDealLabel,
  secondaryText,
  textClassName,
}: Props) {
  return (
    <p
      className={`mhg-alpha-typography-button-2 min-w-0 flex-1 pl-spacing/padding/soft-8px ${textClassName}`}
    >
      {flashDealLabel ? (
        <>
          <span className="block">{flashDealLabel}</span>
          <span className="block">{secondaryText}</span>
        </>
      ) : (
        <span className="line-clamp-2">{deadlineText}</span>
      )}
    </p>
  );
}
